"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v14Upgrade = exports.v14Downgrade = void 0;
const v14Downgrade = (rule) => {
    const { ubCode, clientUuid, embUuid, 
    // variantLetter,
    trigger, published, frequency, referrerTargets, id, integrations, event, version, parentVersion, dimensions, meta, urlTargets, cookieTargets, geoTargets, scheduling, displaySettings, } = rule;
    return {
        schemaVersion: 13,
        ubCode,
        clientUuid,
        embUuid,
        trigger,
        published,
        frequency,
        referrerTargets,
        id,
        integrations,
        event,
        version,
        parentVersion,
        dimensions,
        meta,
        urlTargets,
        cookieTargets,
        geoTargets,
        scheduling,
        displaySettings,
    };
};
exports.v14Downgrade = v14Downgrade;
const v14Upgrade = (rule) => {
    const { ubCode, clientUuid, embUuid, trigger, published, frequency, referrerTargets, id, integrations, event, version, parentVersion, dimensions, meta, urlTargets, cookieTargets, geoTargets, scheduling, displaySettings, } = rule;
    return {
        schemaVersion: 14,
        ubCode,
        clientUuid,
        embUuid,
        variantLetter: 'a',
        trigger,
        published,
        frequency,
        referrerTargets,
        id,
        integrations,
        event,
        version,
        parentVersion,
        dimensions,
        meta,
        urlTargets,
        cookieTargets,
        geoTargets,
        scheduling,
        displaySettings,
    };
};
exports.v14Upgrade = v14Upgrade;
//# sourceMappingURL=v14.js.map